export const RefundSteps = {
  FORM: 'form',
  CONFIRMATION: 'confirmation',
  APPROVALS: 'approvals',
} as const

export type RefundStep = (typeof RefundSteps)[keyof typeof RefundSteps]
